import { colors } from "src/theme/colors";
import { line } from "src/theme/ui";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { SIDEBAR } from "src/components/FinaLayout/utils/sizes";
/* `$isActive` carries the dollar for the same reason `$collapse` does:
   styled-components forwards anything it does not recognise to the element
   underneath, and `isActive` on a Link ended up on the <a>, where React
   warned about an unknown attribute on every render of the rail. */
export const StyledItemLink = styled(Link)`
  /* Football's nav row: 38px on a 9px corner, 13.5px type, and two weights
     that are deliberately not 500/600 — 470 for a destination you are not on
     and 560 for the one you are, close enough that the rail does not look
     like a list with one bold entry in it. */
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 38px;
  margin: 2px 0;
  border: none;
  border-radius: 9px;
  font-size: 13.5px;
  letter-spacing: -0.008em;
  background-color: ${({ $isActive }) =>
    $isActive ? colors.primary[10] : "transparent"};
  color: ${({ $isActive }) =>
    $isActive ? colors.primary[700] : colors.gray[700]};
  font-weight: ${({ $isActive }) => ($isActive ? 560 : 470)};

  /* Collapsed, the row is just the icon: centred in the rail, with the label
     out of the flow instead of overflowing it and being clipped. */
  justify-content: ${({ $collapse }) => ($collapse ? "center" : "flex-start")};
  width: ${({ $collapse }) => ($collapse ? "40px" : "100%")};
  padding: ${({ $collapse }) => ($collapse ? "0" : "0 11px 0 13px")};
  column-gap: 11px;
  transition: background-color 0.15s ease, color 0.15s ease;

  span {
    display: ${({ $collapse }) => ($collapse ? "none" : "inline")};
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /* The marker for the current page sits OUTSIDE the row, flush with the
     rail's own edge: it marks the page against the sidebar rather than
     against the button, which is what makes it read as a position in the
     navigation and not as part of the row's fill. */
  &::before {
    content: "";
    position: absolute;
    top: 7px;
    bottom: 7px;
    left: ${({ $collapse }) => ($collapse ? "-8px" : "-12px")};
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: ${colors.primary[500]};
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    transition: opacity 0.15s ease;
  }

  /* The glyphs are stroked and take their colour from the row, so there is
     nothing to fill. */
  svg {
    flex: none;
    transition: color 0.15s ease;
  }

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? colors.primary[10] : colors.gray[50]};
    color: ${({ $isActive }) =>
      $isActive ? colors.primary[700] : colors.gray[900]};
    cursor: pointer;
  }

  /* A press gives a little and springs back. Football scales the row rather
     than nudging it down, which does not shift the text off its baseline. */
  &:active {
    transform: scale(0.985);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &:active {
      transform: none;
    }
  }
`;
/* The same row, as a button. Deposit and withdraw open a dialog rather than
   navigating, so their rows cannot be links — but they must be
   indistinguishable from the ones that are, so the chrome is the link's,
   applied to a button and with the button's own defaults cleared. */
export const StyledItemButton = styled.button`
  /* Football's nav row: 38px on a 9px corner, 13.5px type, and two weights
     that are deliberately not 500/600 — 470 for a destination you are not on
     and 560 for the one you are, close enough that the rail does not look
     like a list with one bold entry in it. */
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 38px;
  margin: 2px 0;
  border: none;
  border-radius: 9px;
  font-size: 13.5px;
  letter-spacing: -0.008em;
  background-color: ${({ $isActive }) =>
    $isActive ? colors.primary[10] : "transparent"};
  color: ${({ $isActive }) =>
    $isActive ? colors.primary[700] : colors.gray[700]};
  font-weight: ${({ $isActive }) => ($isActive ? 560 : 470)};

  /* Collapsed, the row is just the icon: centred in the rail, with the label
     out of the flow instead of overflowing it and being clipped. */
  justify-content: ${({ $collapse }) => ($collapse ? "center" : "flex-start")};
  width: ${({ $collapse }) => ($collapse ? "40px" : "100%")};
  padding: ${({ $collapse }) => ($collapse ? "0" : "0 11px 0 13px")};
  column-gap: 11px;
  transition: background-color 0.15s ease, color 0.15s ease;

  span {
    display: ${({ $collapse }) => ($collapse ? "none" : "inline")};
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /* The marker for the current page sits OUTSIDE the row, flush with the
     rail's own edge: it marks the page against the sidebar rather than
     against the button, which is what makes it read as a position in the
     navigation and not as part of the row's fill. */
  &::before {
    content: "";
    position: absolute;
    top: 7px;
    bottom: 7px;
    left: ${({ $collapse }) => ($collapse ? "-8px" : "-12px")};
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: ${colors.primary[500]};
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    transition: opacity 0.15s ease;
  }

  /* The glyphs are stroked and take their colour from the row, so there is
     nothing to fill. */
  svg {
    flex: none;
    transition: color 0.15s ease;
  }

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? colors.primary[10] : colors.gray[50]};
    color: ${({ $isActive }) =>
      $isActive ? colors.primary[700] : colors.gray[900]};
    cursor: pointer;
  }

  /* A press gives a little and springs back. Football scales the row rather
     than nudging it down, which does not shift the text off its baseline. */
  &:active {
    transform: scale(0.985);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &:active {
      transform: none;
    }
  }
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  appearance: none;
  background-clip: padding-box;
`;

export const StyledUsername = styled.div`
  display: flex;
  align-items: center;
  /* Collapsed, the avatar and the collapse control stack: 56px of rail has no
     room for two things side by side, and the control has to be reachable in
     both states or an closed rail cannot be reopened. */
  flex-direction: ${({ $collapse }) => ($collapse ? "column" : "row")};
  /* 2rem of padding does not fit in the collapsed rail, so the avatar was
     pushed straight out of it. Collapsed, it is centred with no padding. */
  justify-content: ${({ $collapse }) => ($collapse ? "center" : "flex-start")};
  gap: ${({ $collapse }) => ($collapse ? "10px" : "10px")};
  border-top: 1px solid ${line.soft};
  padding: ${({ $collapse }) => ($collapse ? "1.25rem 0" : "1.25rem 1rem")};
  /* While the rail animates open, the name is laid out before there is room
     for it. Clip it here and it slides into view instead of reflowing —
     and it never spills outside the rail on the way. */
  overflow: hidden;

  /* The avatar is a flex item, and antd gives it overflow: hidden, which makes
     its automatic minimum width 0. A long name competing for the row shrank it
     from a circle into an oval, so keep it at its own size and let the name
     wrap instead. */
  .ant-avatar {
    flex: none;
    background: ${colors.primary[15]};
    color: ${colors.primary[600]};
  }
`;
export const StyledUsernameText = styled.span`
  font-size: 14px;
  color: ${colors.gray[800]};
  font-weight: 500;
  line-height: 1.3;
  /* Pinned to the width it will have once the sidebar is open — the row's
     1rem of padding either side, the 32px avatar and the 10px gap — so the
     name wraps the same way at every point of the transition. Left to size
     itself, it was laid out against a rail still 64px wide and broke one
     word per line, then reflowed as the width grew. */
  flex: none;
  /* The rail's width less its 2rem of padding, the 32px avatar and its 10px
     gap, and the 28px collapse control and its own 10px gap. Everything on
     the row is a fixed size, so the name takes exactly what is left — and
     without the last term it took the control's width too and pushed it out
     of the rail. */
  width: calc(${SIDEBAR} - 2rem - 42px - 38px);
`;
